<template>
  <div id="roleSetUp">
    <div class="card">
      <div class="add_role d_f">
        <div class="c_p" @click="onRoleAddShow(true)">
          <i class="icon iconfont icon-tianjia"></i>
          <span>{{$t('common.AddRole')}}</span>
        </div>
      </div>
      <table class="role">
        <thead>
          <tr>
            <td>{{$t('common.RoleName')}}</td>
            <td>{{$t('common.Description')}}</td>
            <td>{{$t('common.Action')}}</td>
          </tr>
        </thead>
        <tbody>
          <template v-if="roleData.items && roleData.items.length !== 0">
            <tr v-for="(item, index) in roleData.items" :key="index">
              <td>{{ item.RoleName }}</td>
              <td>{{ item.Description }}</td>
              <td>
                <i
                  v-if="
                    item.RoleName !== 'ASM' &&
                      item.RoleName !== 'RSD' &&
                      item.RoleName !== 'NSD' &&
                      item.RoleName !== 'Admin'
                  "
                  class="icon iconfont icon-bianji1 c_p"
                  style="margin-right: 30px"
                  @click="roleEdit(item)"
                ></i>
                <i
                  v-if="
                    item.RoleName !== 'ASM' &&
                      item.RoleName !== 'RSD' &&
                      item.RoleName !== 'NSD' &&
                      item.RoleName !== 'Marketing' &&
                      item.RoleName !== 'Admin'
                  "
                  class="icon iconfont icon-lajitong c_p"
                  @click="roleDel(item)"
                ></i>
              </td>
            </tr>
          </template>
          <tr v-else>
            <th colspan="8">{{$t('common.noData')}}</th>
          </tr>
        </tbody>
      </table>
      <page
        :totalPage="roleData.pages"
        :page="roleData.offset"
        @on-getList="rolePageChange"
        v-if="roleData.items && roleData.items.length !== 0"
      ></page>
    </div>
    <!-- 添加/编辑角色 -->
    <Dialog
      :show="roleAddShow"
      @cancel="roleAddCancel"
      @confirm="roleAddConfirm"
      :title="add ? $t('common.AddRole') : $t('common.EditRole')"
      width="50%"
      top="2%"
      :buttonFixed='true'
    >
      <div slot="content">
        <div class="roleAdd_content">
          <div>
            <div class="form_item">
              <div class="form_text">
                <i style="color:#c61743">*</i>
                <span>{{$t('common.RoleName')}}</span>
              </div>
              <div>
                <input
                  type="text"
                  v-model.trim="moduletreeForm.RoleName"
                  :disabled="!add ? true : false"
                />
              </div>
            </div>
            <div class="form_item">
              <div class="form_text">
                <span>{{$t('common.Description')}}</span>
              </div>
              <div>
                <input type="text" v-model="moduletreeForm.Description" />
              </div>
            </div>
          </div>
          <div class="role_moduletree">
            <div class="title">
              <i></i>
              <span>{{$t('common.PermissionSettings')}}</span>
            </div>
            <div class="select_option">
              <Tree :data="moduletree" v-model="moduletreeForm" :brandList="brandList"></Tree>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 删除角色 确认框 -->
    <Dialog
      :show="roleDelShow"
      @cancel="roleDelCancel"
      @confirm="roleDelConfirm"
      :title="$t('common.DeleteRolerMsg')"
    />
  </div>
</template>

<script>
import Dialog from '@/components/myComponents/dialog'
import Tree from '@/components/myComponents/tree'
export default {
  name: 'roleSetUp',
  data () {
    return {
      roleData: {},
      roleAddShow: false,
      moduletree: [],
      moduletreeForm: {
        Id: 0,
        RoleName: '',
        Description: '',
        Modules: []
      },
      roleDelShow: false,
      roleDelID: 0,
      add: null,
      brandList: []

    }
  },
  methods: {
    getRoleData (pageIndex = 1, pageSize = 11) {
      this.$axiox
        .get(
          `/api/v1/admin/role/list?pageIndex=${pageIndex}&pageSize=${pageSize}`
        )
        .then(res => {
          this.roleData = res.data
        })
    },
    rolePageChange (val) {
      this.getRoleData(val, 11)
    },
    roleAddCancel (val) {
      this.roleAddShow = val
      // 合并重置
      Object.assign(this.moduletreeForm, this.$options.data().moduletreeForm)
      this.modelTree()
    },
    roleAddConfirm (val) {
      if (this.moduletreeForm.RoleName === '') {
        return this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.RequiredFields'),
          stayTime: 5
        })
      }
      if (this.add === true) {
        if (
          this.roleData.items.some(items => {
            return items.RoleName === this.moduletreeForm.RoleName
          })
        ) {
          return this.$commonJs.alertTips({
            type: 'error',
            content: this.$t('common.RoleAlreadyExists'),
            stayTime: 5
          })
        }
      }
      let modules = []
      this.moduletreeForm.Modules.forEach(item => {
        item.Children.forEach(items => {
          let readonly = null
          let editable = null
          if (items.Authority === '2') {
            readonly = true
            editable = true
          } else if (items.Authority === '1') {
            readonly = true
            editable = false
          } else {
            readonly = false
            editable = false
          }
          let brandCode = ''
          if (items.BrandCode) {
            brandCode = items.BrandCode.join(',')
          }
          let modul = {
            moduleId: items.Id,
            readonly,
            editable,
            brandCode
          }
          if (items.Authority !== '0') {
            modules.push(modul)
          }
        })
      })
      let moduletreeForm = {
        id: this.moduletreeForm.Id,
        roleName: this.moduletreeForm.RoleName,
        description: this.moduletreeForm.Description,
        modules
      }
      this.$axiox.post(`/api/v1/admin/role`, moduletreeForm).then(res => {
        if (res.success) {
          this.$commonJs.alertTips({
            type: 'success',
            content: this.add ? this.$t('common.AddSuccess') : this.$t('common.EditSuccess'),
            stayTime: 5
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            title: '失败',
            content: this.add ? this.$t('common.AddFailed') : this.$t('common.EditFailed'),
            stayTime: 5
          })
        }
        this.roleAddShow = val
        // 合并重置
        Object.assign(this.moduletreeForm, this.$options.data().moduletreeForm)
        this.modelTree()
        this.getRoleData(this.roleData.offset, 11)
      })
    },
    onRoleAddShow (flag) {
      this.add = flag
      this.roleAddShow = true
    },
    roleEdit (item) {
      this.$axiox.get(`/api/v1/admin/role/${item.Id}`).then(res => {
        this.moduletreeForm = res.data
        this.onRoleAddShow(false)
        this.roleAddShow = true
      })
    },
    roleDel (item) {
      this.roleDelShow = true
      this.roleDelID = item.Id
    },
    roleDelCancel (val) {
      this.roleDelShow = val
    },
    roleDelConfirm (val) {
      this.$axiox.del(`/api/v1/admin/role/${this.roleDelID}`).then(res => {
        this.roleDelShow = val
        this.getRoleData(this.roleData.offset, 11)
        if (res.success) {
          this.$commonJs.alertTips({
            type: 'success',
            content: this.$t('common.DeleteSuccess'),
            stayTime: 5
          })
        } else {
          this.$commonJs.alertTips({
            type: 'error',
            content: this.$t('common.DeleteFailed'),
            stayTime: 5
          })
        }
      })
    },
    modelTree () {
      this.moduletree.forEach(item => {
        let obj = {
          Id: item.Id,
          Code: item.Code,
          Name: item.Name,
          IsEnabled: false,
          Readonly: false,
          Editable: false,
          Children: []
        }
        item.Children.forEach(items => {
          let objChildren = {
            Id: items.Id,
            Code: items.Code,
            Name: items.Name,
            IsEnabled: false,
            Readonly: false,
            Editable: false,
            BrandCode: []
          }
          obj.Children.push(objChildren)
        })
        this.moduletreeForm.Modules.push(obj)
      })
    }
  },
  beforeCreate () {
    this.$parent.topName = this.$t('common.RoleManagement')
  },
  created () {
    this.getRoleData(this.roleData.offset, 11)
    this.$axiox.get(`/api/v1/admin/role/moduletree`).then(res => {
      this.moduletree = res.data
      this.modelTree()
    })
    this.$axiox.get(`/api/v1/admin/brand/pagedList?pageIndex=1&pageSize=100&sort=id&order=asc`).then(res => {
      this.brandList = res.data.items
    })
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    document.getElementById('index').addEventListener('click', closeMenu)
  },
  destroyed () {
    document.getElementById('index').removeEventListener('click', closeMenu)
  },
  components: {
    Dialog,
    Tree
  }
}
function closeMenu () {}
</script>

<style scoped>
.card {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 20px 8px 10px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 0px 10px 1px rgb(223, 218, 218);
}
.add_role {
  justify-content: flex-end;
}
.add_role div {
  margin-right: 25px;
  padding: 4px 22px;
  color: white;
  font-size: 13px;
  background-color: #c50f3c;
  border-radius: 18px;
}
.add_role i {
  color: white;
}
.role {
  margin-top: 18px;
  width: 100%;
  border-collapse: collapse;
}
thead {
  background-color: #fff1f4;
  border-bottom: 3px solid #e27f97;
  font-size: 13px;
  font-weight: 600;
}
.role td {
  padding: 0.8% 0 0.8% 2%;
  /* white-space: nowrap; */
}
tbody {
  border-bottom: 2px solid #dfdfdf;
}
tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}
th {
  text-align: center;
  color: #8b8686;
  padding: 40px;
  font-size: 14px;
  font-weight: 400;
}
.roleAdd_content {
  margin: 0 auto;
  width: 86%;
}
.form_item {
  margin-bottom: 16px;
}
.form_item input {
  padding: 8px 6px;
  margin-left: 20px;
  border: 1px solid #da6985;
  border-radius: 4px;
  width: 82%;
}
.form_text {
  float: left;
  width: 76px;
  text-align: right;
  line-height: 33px;
}
.role_moduletree {
  margin: 24px 0;
}
.role_moduletree .title i {
  display: inline-block;
  width: 8px;
  height: 20px;
  margin-right: 8px;
  background-color: #c50f3c;
}
.role_moduletree .title span {
  color: #c9244d;
  font-size: 13px;
  font-weight: 600;
}
.select_option {
  margin-top: 16px;
  padding: 10px 20px;
}
.select_option::-webkit-scrollbar {
  width: 4px;
}
.select_option::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.iconfont {
  color: #c50f3c;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/RoleSetUp.vue